import React, { useEffect, useState } from 'react';
//import { Link, useNavigate } from "react-router-dom";
import { httpRequest, httpAuthHeaders } from '../../../services/httpService';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import helpers from '../../../services/helpers';
import Loader from '../../parts/Loader';
import { getApiData } from '../../../services/apiService';
 
export default function ProductUnitListModal ({
    is_show = false, 
    setShow, 
    handleSelect, 
    customer_id,
    exclude=[]
}){
    const [loading, setLoading] = useState(0);
    const [name, setName] = useState('');
    const [notice, setNotice] = useState('');
    const [data_list, setDataList] = useState([]);
    const [table_data, setTableData] = useState([]);
    const [show_address_modal, setShowAddressModal] = useState(0);
   
    useEffect(() => {

    }, []);
   
    useEffect(() => {
        if(is_show && customer_id) {
            setNotice()
            fetchData()
        }
    }, [is_show]);
   
    useEffect(() => {
        let table_items_lg = []
        let table_items_sm = []
        
        if (Object.keys(data_list).length > 0) {
            table_items_lg = Object.entries(data_list).map(([key, data]) => {
                const is_existed = helpers.isObjectExist(exclude, data.id)
                if(is_existed) return;

                return (<tr key={data.id} style={{fontSize: '15px'}}>
                            <td>{data?.qr_code ? data.qr_code : '---'}</td>
                            <td>{data?.brand ? data.brand : '---'}</td>
                            <td>{data?.serial_no ? data.serial_no : '---'}</td>
                            <td>{data?.invoice_no ? data?.invoice_no : '---'}</td>
                            <td width={50}><button className='btn btn-sm btn-outline-primary' type="button" onClick={(e) => onSelect(data)}>Select</button></td>
                        </tr>)
            })
            table_items_sm = Object.entries(data_list).map(([key, data]) => {
                const is_existed = helpers.isObjectExist(exclude, data.id)
                if(is_existed) return;

                return (<tr key={data.id} style={{fontSize: '15px'}}>
                            <td>
                                QR Code: {data?.qr_code ? data.qr_code : '---'}<br/>
                                Brand: {data?.brand ? data.brand : '---'}<br/>
                                Serial No: {data?.serial_no ? data.serial_no : '---'}<br/>
                                Invoice #: {data?.invoice_no ? data?.invoice_no : '---'}
                            </td>
                            <td width={50}><button className='btn btn-sm btn-outline-primary' type="button" onClick={(e) => onSelect(data)}>Select</button></td>
                        </tr>)
            })
        }
        else{
            table_items_lg = <tr key={'no-data-lg'} style={{fontSize: '15px'}}>
                                <td colSpan={5} className='text-center'>No data to dsiplay.</td>
                            </tr>

            table_items_sm = Object.entries(data_list).map(([key, data]) => {
                const is_existed = helpers.isObjectExist(exclude, data.id)
                if(is_existed) return;

                return (<tr key={'no-data-sm'} style={{fontSize: '15px'}}>
                            <td colSpan={5} className='text-center'>No data to diplay.</td>
                        </tr>)
            })
        }

        setTableData(
            <div>
                <div className='d-none d-md-block'>
                    <table className='table table-hover table-sm mb-0 mt-3'>
                        <thead className='bg-light'>
                            <tr>
                                <th>QR Code</th>
                                <th>Brand</th>
                                <th>Serial</th>
                                <th>Invoice #</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>{table_items_lg}</tbody>
                    </table>
                </div>
                <div className='d-block d-md-none'>
                    <table className='table table-hover table-sm mb-0 mt-3'>
                        <tbody>{table_items_sm}</tbody>
                    </table>
                </div>
            </div>
        )
    }, [data_list]);

    async function fetchData(name) {
        setLoading(1)

        let filter = `?store_id=${helpers.getStoreID()}&paginate=0&`
        if(name){
            filter += `search=${name}&`
        }
        if(customer_id){
            filter += `customer_id=${customer_id}&`
        }
            
        filter = filter.slice(0, -1)
        
        //let enpoint = `V1/manage/invoices${filter}`
        let endpoint = helpers.createServiceHubUrl(`v1/product-details${filter}`)

        const res = await getApiData(endpoint, false)
        if(res.length){
            setDataList(res)
            setLoading(0)
        }
        else{
            reset()
            setLoading(0)
            //setNotice(<div className="alert alert-info mt-3 px-3 py-2 mb-0" role="alert">No data to display.</div>)
        }
    }

    function handleClose(e) {
        reset();
        setShow(0);
    }

    function onSelect(e){
        reset();
        setShow(0);
        handleSelect(e)
    }

    function inputChange(e) {
        let { value, name } = e.target;
        
        if(!value) {
            //setNotice('Invoice field is required') 
        }

        if(value) setNotice('');

        //setName(value);
        fetchData(value)
    }

    function reset(){
        setName('')
        setDataList([])
        setTableData([])
        setNotice('')
    }

    return (
        <>
            <Modal show={is_show} size="lg">
                <Modal.Header>
                    <h5>PolarCare Units</h5>
                    <Button variant="danger" size="sm" onClick={handleClose}><i className="fas fa-times"></i></Button>
                </Modal.Header>
                <Modal.Body style={{position: 'relative'}}>
                    <Loader isLoading={loading}/>
                    <div className="row">
                        <div className="col-9s col-md-10s col-12">
                            <div className="input-group">
                                <input type="text" className="form-control" placeholder="Search Unit, QR Code, Serial" aria-label="Invoice #" aria-describedby="basic-addon2" onChange={inputChange} autoFocus />
                                {/* <div className="input-group-append">
                                    <button className="btn btn-outline-primary" type="button" onClick={fetchData}>Search</button>
                                </div> */}
                            </div>
                        </div>
                        
                        {/* <div className="col-3 col-md-2">
                            <button className="btn btn-primary w-100" type="button" onClick={(e) => setShowAddressModal(1)}><i className="fas fa-plus-circle mr-2" />New</button>
                        </div> */}
                    </div>
                    
                    <span className='text-danger'>{notice}</span>

                    {table_data}
                </Modal.Body>
            </Modal>
        </>
    )
}